import * as Html from "../util/Html.ts";
import {ContactCache} from "../contact/ContactCache.js";
import { SearchController, easyScorer } from "./searchController.js";
import CONTACTS_LIST_TEMPLATE from "../contact/contacts_list_item.mustache";
import CONTACTS_LIST_NOMATCH from "../contact/contacts_list_nomatch.mustache";


export {init,destroy}

Html.registerWidget('widget/SearchContact',{init:init})

var controller;

function init(o){
    controller = new SearchController(o,o.parent().find('input'),CONTACTS_LIST_TEMPLATE,CONTACTS_LIST_NOMATCH,ContactCache,easyScorer({firstName:4,lastName:5,devices:{value:3}}))
}
function destroy(o){
    controller.destroy();
    controller = undefined;
}